import { render, staticRenderFns } from "./WarningsTpl.vue?vue&type=template&id=0381050a"
import script from "./WarningsTpl.vue?vue&type=script&lang=js"
export * from "./WarningsTpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports